const GetUserRole = (role) => {
    if(role === 'OWNER') {
        return 'مالك الحساب';
    } else if(role === 'ADMINSTRATOR') {
        return 'مدير';
    } else if(role === 'EMPLOYEE') {
        return 'موظف';
    } else {
        return 'غير معرف';
    }
}

export default GetUserRole;